
export default function Problem() {
  const risks = [
    {
      icon: 'ri-tools-line',
      title: '機械の全損',
      description:
        '基盤やロボットアームの隙間に粉が入り込み、腐食・ショート。資産価値がゼロに。',
      color: 'text-red-600',
      bgColor: 'bg-red-50',
    },
    {
      icon: 'ri-time-line',
      title: '長期の操業停止',
      description:
        '専門業者による特殊清掃で数日間ライン停止。納期遅延による損害賠償リスク。',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: '健康被害',
      description: '閉鎖空間での粉末吸入による作業員の呼吸器被害。',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
    },
  ];

  return (
    <section id="problem" className="py-14 md:py-24 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block bg-red-100 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-4 md:mb-6">
            問題提起
          </div>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6" style={{ lineHeight: '1.5' }}>
            火は消えてもその「粉」が
            <br />
            工場を破壊する
          </h2>
          <div className="max-w-3xl mx-auto space-y-3 text-base md:text-lg text-gray-700">
            <p>
              初期消火に成功しても、一般的な「ABC粉末消火器」を使えば現場は微細な粉末に覆われます。
            </p>
            <p className="text-base md:text-xl font-bold text-red-600">
              それは単なる汚れではありません。「生産停止」という経営リスクです。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
          {risks.map((risk, index) => (
            <div
              key={index}
              className={`${risk.bgColor} rounded-2xl p-6 md:p-8 hover:shadow-xl transition-all duration-300`}
            >
              <div className="flex items-center justify-center mb-4 md:mb-6">
                <div className={`w-14 h-14 md:w-16 md:h-16 ${risk.bgColor} rounded-full flex items-center justify-center`}>
                  <i className={`${risk.icon} text-3xl md:text-4xl ${risk.color}`}></i>
                </div>
              </div>
              <h3 className={`text-xl md:text-2xl font-bold ${risk.color} mb-3 md:mb-4 text-center`}>
                {risk.title}
              </h3>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed text-center">{risk.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-16 bg-gradient-to-r from-red-50 to-orange-50 rounded-2xl p-6 md:p-10 text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
            <i className="ri-alert-line text-2xl md:text-3xl text-white"></i>
          </div>
          <p className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">3つの致命的リスク</p>
          <p className="text-sm md:text-lg text-gray-700 max-w-3xl mx-auto">
            消火器の粉末は、火災そのものよりも深刻な二次被害を引き起こします。
            <br />
            あなたの工場は、本当に守られていますか？
          </p>
        </div>
      </div>
    </section>
  );
}
